<template>
  <div class="violation-detail mar-top">
    <div class="title-box">
      <div class="violation-title">
        <h4>{{cellList[curTagIndex].tag}}</h4>
        <div class="violate-icon">
          <i :class="{
            'iconfont icon-bugaoxing': true,
            'active': violationDetail[curTagIndex].violationGrade >= 1
          }"></i>
          <i :class="{
            'iconfont icon-bugaoxing': true,
            'active': violationDetail[curTagIndex].violationGrade >= 2
          }"></i>
          <i :class="{
            'iconfont icon-bugaoxing': true,
            'active': violationDetail[curTagIndex].violationGrade >= 3
          }"></i>
          <i :class="{
            'iconfont icon-bugaoxing': true,
            'active': violationDetail[curTagIndex].violationGrade >= 4
          }"></i>
          <span>{{violationDetail[curTagIndex].violationGrade | filterVoilateGrade}}</span>
        </div>
      </div>
    </div>
    <div class="detail-box">
      <div class="detail-box-item">
        <div>
          <i class="iconfont icon-pingjia"></i>
          <span class="blod">{{cellList[curTagIndex].type === 10 || cellList[curTagIndex].type === 8 || cellList[curTagIndex].type === 13 ? '限制说明' : '违规说明'}}</span>
        </div>
        <p class="desc">
          <span v-html="violationDetail[curTagIndex].desc"></span>
          <br/>
          <span class="contact-color" @click="contactCs" v-if="violationDetail[curTagIndex].contact">联系客服</span>
        </p>
      </div>
      <div class="detail-box-item" v-if="violationDetail[curTagIndex].violation">
        <div>
          <i class="iconfont icon-warn"></i>
          <span class="blod m-left">处理方式</span>
        </div>
        <p class="desc" v-html="violationDetail[curTagIndex].violation"></p>
      </div>
    </div>
    <div class="bottom-btn">
      <mt-button type="primary" @click="goBack">返回</mt-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      curTagIndex: 0,
      cellList: [
        { tag: '使用淘宝客', type: 3 },
        { tag: '关键词作弊', type: 2 },
        { tag: '向客服提及违规话语', type: 7 },
        { tag: '评价抄袭', type: 9 },
        { tag: '违反平台规则', type: 5 },
        { tag: '负面评价', type: 4 },
        { tag: '退款不退还返利', type: 1 },
        // { tag: '自行申请退款', type: 0 },
        { tag: '平台风险控制', type: 10 },
        { tag: '其他限制', type: 8 },
        { tag: '申请发票', type: 11 },
        { tag: '投诉商家', type: 12 },
        { tag: '管理员临时限制', type: 13 },
        { tag: '使用其他红包优惠', type: 12 }
      ],
      violationDetail: [
        // 内容顺序和cellList索引对应
        {
          desc: '在淘宝下单时，使用从非淘宝官方获得的优惠券、红包等可抵扣金额的福利或通过第三方推广链接进入淘宝APP进行购买的行为，将被视为使用淘宝客。<br>在618、双11等大促活动期间，在下单时使用活动超级红包或消费券，也将会被视为使用淘宝客。购物时确保仅使用淘宝APP搜索下单，请勿使用各类优惠。',
          contact: false, // 是否展现【联系客服按钮】
          violationGrade: 2, // 违规的严重程度
          violation: '一经发现，已完成订单需退还淘客佣金；若不配合平台处理，则每次扣除行为分3分。未完成订单系统自动取消接手。且在使用淘客下单后，会有15天的淘客计算周期；平台为保护商家权益，在此15天内会限制买手购买同店铺的商品<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '作弊行为包括但不限于：拍立淘/拍照搜同款、搜索店铺名、不按关键词进入。',
          contact: false,
          violationGrade: 2,
          violation: '一经发现，需进行退款。若不配合平台处理，则每次扣除行为分3分。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '私自在对应购物平台上向客服提及搜货平台、返利等违规话语，如对返利相关事宜有疑问请联系搜货客服。',
          contact: true,
          violationGrade: 2,
          violation: '一经发现，需接受教育，保证下次不再联系店铺客服。若不配合平台处理，则每次扣除行为分3分。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '一切使用非本人拍摄图片或编辑内容进行评价的行为，包括但不限于从商品评价列表“盗取”评价内容或晒图。',
          contact: false,
          violationGrade: 2,
          violation: '一经发现，需删除评价，或重新拍摄收到的货品图进行追评。若不配合平台处理，则每次扣除行为分3分。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '未遵守平台规则，如要求好评返现，商家不答应则差评威胁或者投诉等行为',
          contact: false,
          violationGrade: 3,
          violation: '一经发现，每次违规扣除行为分6分；情节严重者，平台有权直接进行封号。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '在商品质量没问题的情况下，在对应购物平台上对商品进行负面评价的行为。',
          contact: false,
          violationGrade: 3,
          violation: '一经发现，需删除评价，或重新拍摄收到的货品图进行追评。若不配合平台处理，则每次扣除行为分6分。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '确认收货并在平台领取返利后，故意到对应购物平台上申请退款，商家同意退款后不归还已领取的返利金额。',
          contact: false,
          violationGrade: 4,
          violation: '出现违规将永久封号，并扣除行为分12分，公开失信者信息，情节严重移交公安处理。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        // {
        //   desc: '提交订单后，用户自行到淘宝申请退款，系统会自动对账户进行提现限制，请联系客服说明情况，处理完毕后可解除限制',
        //   contact: true,
        //   violationGrade: 1,
        //   violation: ''
        // },
        {
          desc: '搜货平台出于风险考虑，会暂时对存在可疑购买行为的账号进行限制提现操作，限制账号只需等待系统自动解除限即可，限制提现期间账号仍可进行购买。如有异议，可联系客服了解详情。',
          contact: true,
          violationGrade: 1,
          violation: '情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '用户在平台存在待处理事项，需暂时限制提现，请联系客服，处理完毕后可解除限制。',
          contact: true,
          violationGrade: 1,
          violation: '情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '在平台购买的所有返利商品均不支持开发票，出现申请发票拒不撤销的情况将被视为违规。',
          contact: false,
          violationGrade: 2,
          violation: '一经发现，需撤销发票申请。若不配合平台处理，则每次扣除行为分3分。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '在商品质量没问题且商家服务较好的情况下，恶意向对应购物平台官方对商家进行投诉，造成商家损失的行为。',
          contact: false,
          violationGrade: 3,
          violation: '一经发现，需撤销投诉；若不配合平台处理，则每次将扣除行为分6分。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '用户在平台存在待处理事项，需暂时限制提现，请联系客服，处理完毕后可解除限制。',
          contact: true,
          violationGrade: 1,
          violation: '情节严重者，平台有权冻结帐号，停止提供服务。'
        },
        {
          desc: '在下单时，使用首单礼金、月卡红包、店铺红包等其他优惠红包抵扣下单金额进行购买的行为。',
          contact: false,
          violationGrade: 2,
          violation: '一经发现，需退回对应红包金额或退款处理；若不配合平台处理，则每次扣除行为分3分。<br>情节严重者，平台有权冻结帐号，停止提供服务。'
        }
      ]
    }
  },
  created () {
    this.curTagIndex = parseInt(this.$route.query.type) || 0
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    contactCs () {
      this.$router.push({
        name: 'posterDetail',
        query: {
          isContact: 1
        }
      })
    }
  },
  filters: {
    filterVoilateGrade (grade) {
      switch (grade) {
        case 1:
          return '临时限制'
        case 2:
          return '普通违规'
        case 3:
          return '严重违规'
        case 4:
          return '恶意违规'
        default:
          return '临时违规'
      }
    }
  }
}
</script>

<style scoped>
  .violation-detail{
    background: #f2f2f2;
    overflow: hidden;
    min-height: 100vh;
  }
  .violation-detail .title-box{
    background: #ffffff;
  }
  .violation-detail .detail-box{
    padding: 15px 20px;
    box-sizing: border-box;
    font-size: 15px;
    background: #ffffff;
  }
  .violation-title{
    padding: 20px 0;
    margin: 0 20px;
    box-sizing: border-box;
    background: #fff;
    border-bottom: 1px solid #eee;
    font-size: 22px;
  }
  .violation-title .violate-icon{
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 15px;
  }
  .violation-title.violate-icon .iconfont{
    color: #999;
    font-size: 18px;
    margin-right: 5px;
  }
  .violate-icon .iconfont{
    margin-right: 3px;
    margin-left: 2px;
    margin-top: 1px;
  }
  .violate-icon .iconfont.active{
    color: #ff0000;
  }
  .violation-title .violate-icon span{
    margin-left: 5px;
    color: #ff0000;
  }
  .detail-box-item{
    position: relative;
    margin-top: 15px;
    margin-bottom: 30px;
  }
  .detail-box-item:first-child{margin-top: 0;}
  .detail-box-item .iconfont{
    font-weight: 600;
  }
  .detail-box-item .icon-warn{
    margin-left: 3px;
  }
  .detail-box-item .blod{
    font-weight: 700;
    margin-left: 2px;
  }
  .detail-box-item .m-left{
    margin-left: 6px;
  }
  .detail-box-item .desc{
    font-size: 15px;
    color: #999;
    margin-top: 5px;
    line-height: 22px;
  }
  .contact-color{
    color: #26a2ff;
    cursor: pointer;
  }
  .bottom-btn{
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    width: 40%;
    margin: 0 auto;
    text-align: center;
  }
  .bottom-btn .mint-button{
    width: 100%;
    border-radius: 30px;
    font-size: 14px;
  }
</style>
